var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4a2 2 0 0 1-1.298 1.873l1.527 4.07.716 1.912c.062.074.126.074.165.035l1.444-1.444 2.032-2.032a2 2 0 1 1 1.248.579L19 19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4.166 8.993Q4.084 9 4 9a2 2 0 1 1 1.414-.586l2.033 2.033L8.89 11.89c.087.042.145.016.165-.035l.716-1.912 1.527-4.07A2 2 0 1 1 14 4M6.84 17l-.393-4.725 1.029 1.03a2.1 2.1 0 0 0 3.451-.748L12 9.696l1.073 2.86a2.1 2.1 0 0 0 3.451.748l1.03-1.03L17.16 17z",
    clipRule: "evenodd"
  })));
};
export default SvgCrown;